<script setup>
import { swalError, swalSuccess, parseError } from '@/helper';
import { get_reward_action } from '@/services/reward_actions';
import { create_ticket_reward } from '@/services/tickets';
import { onMounted, ref } from 'vue';


const props = defineProps({
  ticket: {
    type: Object
  },
  meta: {
    type: Object
  }
})

const ticket_type = ref('ticket') // might be used in future
onMounted(async ()=>{
  console.log('during on mounting component')
  ticket_type.value = props.ticket.attributes.ticket_type
  await retrieve_reward_value()
})

const point_value = ref(0)
const reward_action = ref({})
async function retrieve_reward_value(){
  let response = await get_reward_action('feedback_reward')
  if (response.error){
    swalError(response.result, true)
    return
  }
  reward_action.value = response.result.data.data
  point_value.value = response.result.data.data.attributes.point_value
}

async function approveReward(){
  let params = {
    child_id: props.meta.child_id,
    reward_action_id: reward_action.value.id,
    point_value: point_value.value
  }
  let response = await create_ticket_reward(props.ticket.id, params)
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Reward has been approved')
}
</script>

<template>
  <div class="card">
    <CardHeader :is_narrow="true" title="Reward">
    </CardHeader>
    <div class="card-body">
      <div class="row g-3 align-items-center">
        <div class="col-auto">
          <label for="point_value" class="pb-0 col-form-label">
            Suggested point value
          </label>
          <p class="mt-0 form-text">
            Point value can be change if suitable
          </p>
        </div>
        <div class="col-auto">
          <input type="number" 
            id="point_value" class="text-end form-control"
            placeholder="Point value"
            v-model="point_value"
          >
        </div>
      </div>
      <div class="mt-2 row g-2 justify-content-end me-4">
        <div class="col-auto">
          <button class="btn btn-light-success"
            @click="approveReward()"
          >
            Approve Reward
          </button>
        </div>
        <!-- <div class="col-auto">
          <button class=" btn btn-light-danger"
            @click="rejectReward()"
          >
            Reject Reward
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>
